import React from 'react';
import { UltrarubigramStore } from '../_puzzles/Ultrarubigram/UltrarubigramStore';
import UltrarubigramLogo from 'url:./assets/UltrarubigramLogo.svg';
import OutcomeBanner from './OutcomeBanner';

const UltrarubigramPreview = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="previewTile puzzleTile" onClick={onClick}>
      <div className="ultrarubigramPreview">
        <div className="puzzleTitle">Ultrarubigram</div>
        <div className="previewImageContainer">
          <img className="rubigramIcon" src={UltrarubigramLogo}/>
          <OutcomeBanner store={UltrarubigramStore as any} />
        </div>
      </div>
    </div>
  );
};

export default UltrarubigramPreview;
